import Ext from 'Ext'
import BaseDatePicker from './at_base_date_picker'
import DatePicker from './at_date_picker'
Ext.namespace('AT');

const WeekPicker = Ext.extend(BaseDatePicker,
{
    invertedDaysMap : undefined,

    showToday: false,

    initComponent : function()
    {
        WeekPicker.superclass.initComponent.call(this);
        this.selectedWeekTr = null;
        if( Number.NEGATIVE_INFINITY < this.actualMin )
        {
            var date = this.actualMin.getWeekStartDate( this.startDay );
            if( !date.isSameDate( this.actualMin ) )
            {
                date = date.getNDaysAfter( 6 );
            }
            this.actualMin = date;
        }
        if( this.actualMax < Number.POSITIVE_INFINITY )
        {
            this.actualMax = this.actualMax.getWeekStartDate( this.startDay ).getNDaysAfter(6);
        }
    },

    setValue : function(value){
        this.removeSelectedWeekClass();
        value = value.getWeekStartDate( this.startDay );
        WeekPicker.superclass.setValue.call(this, value);
    },

        // override
    update : function(date)
    {
        if (date >= this.actualMin && date <= this.actualMax)
        {
            this.activeDate = date;
        }
        
        if(this.currentWeerRow)
        {
            this.currentWeerRow.style.display = this.todayIsDisabled ? "none" : "table-row";
        }
        this.updateCells( date );
    },

    setCellClasses: function(cell, isWeekend, date, today)
    {
        DatePicker.superclass.setCellClasses.call(this, cell, isWeekend, date, today);

        if( date.clearTime(true).getTime() == this.value.clearTime(true ).getTime() && !this.selectedWeekTr )
        {
            this.selectedWeekTr = cell.parentNode;
            Ext.fly( this.selectedWeekTr ).addClass("at-selected-week");
        }

        if( !cell.previousSibling )
        {
            cell.className += " at-first-day ";
        }
        else if( !cell.nextSibling )
        {
            cell.className += " at-last-day ";
        }
    },

    // override
    onRender : function (container, position)
    {
        WeekPicker.superclass.onRender.call(this, container, position);
        this.currentWeerRow = this.addCurrentWeekButton();
        Ext.get(this.el).addClass("atap-week-picker");
    },

    addCurrentWeekButton: function()
    {
        var tr = document.createElement("tr");
        var td = document.createElement("td");
        td.colSpan = 3;
        td.className ="x-date-bottom";
        td.align = "center";
        tr.appendChild( td );
        var a = document.createElement("a");
        a.innerHTML = "current week";
        td.appendChild( a );
        this.el.dom.firstChild.firstChild.appendChild( tr );

        var self = this;
        a.onclick = function() { self.selectToday() };

        return tr;
    },

    // override
    showPrevYear : function()
    {
        var newDate = this.activeDate.add("y", -1);
        this.update(this.fix29februaryIssue(newDate));
    },

    // override
    showNextYear : function()
    {
        var newDate = this.activeDate.add("y", 1);
        this.update(this.fix29februaryIssue(newDate));
    },

    removeSelectedWeekClass: function()
    {
        if( this.selectedWeekTr )
        {
            Ext.get(this.selectedWeekTr).removeClass("at-selected-week");
            this.selectedWeekTr = null;
        }
    },

    showPrevMonth : function(){
        this.removeSelectedWeekClass();
        this.update(this.activeDate.add("mo", -1));
    },

    showNextMonth : function(){
        this.removeSelectedWeekClass();
        this.update(this.activeDate.add("mo", 1));
    },

    monthPickerApply : function (year, month)
    {
        var d = new Date(year, month, (this.activeDate || this.value).getDate());
        if (d.getMonth() != month){
            // "fix" the JS rolling date conversion if needed
            d = new Date(year, month, 1).getLastDateOfMonth();
        }
        this.update(d);
        this.hideMonthPicker();
        this.removeSelectedWeekClass();
    }

});

Ext.reg('atweekpicker', WeekPicker);

export default WeekPicker



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_week_picker.js